import "./BecomeASupplier.module.css";
import Header from "@/reusable_sections/Header";
import Benefits from "./sections/Benefits";
import SupplierBenefits from "./sections/SupplierBenefits";
import Marketreach from "./sections/Marketreach";
import Partnership from "./sections/Partnership";
import Requirements from "./sections/Requirements";
import SupplierRegistration from "./sections/SupplierRegistration";
import SupplierRegistrationForm from "./sections/SupplierRegistrationForm";
import SupplierFaq from "./sections/SupplierFaq";
import Onboarding from "./sections/Onboarding";
import Registration from "./sections/Registration";
import Footer from "@/reusable_sections/Footer";
export default function BecomeASupplierPage() {
  return <div>
      <Header />
      <Benefits />
      <SupplierBenefits />
      <Marketreach />
      <Partnership />
      <Requirements />
      <SupplierRegistration />
      <SupplierRegistrationForm />
      <SupplierFaq />
      <Onboarding />
      <Registration />
      <Footer />
    </div>;
}